export const getProfile = () => {
  const host = window.location.host;
  if (host === 'localhost:3000') return 'dev';
  if (host === 'staging.app.fresherstoday.com') return 'staging';
  if (host === 'business.fresherstoday.com') return 'production';
};

let getBEUrl = 'https://staging.api.fresherstoday.com';
let cloudUrl = 'https://ictservice.cambri.ai/api/';

const profile = getProfile();
switch (profile) {
  case 'dev':
    getBEUrl = 'https://staging.api.fresherstoday.com';
    cloudUrl = 'https://ictservice.cambri.ai/api/';
    break;
  case 'staging':
    getBEUrl = 'https://staging.api.fresherstoday.com';
    cloudUrl = 'https://ictservice.cambri.ai/api/';
    break;
  case 'production':
    getBEUrl = 'https://api.fresherstoday.com';
    cloudUrl = 'https://ictsystems.cambri.ai/api/';
    break;
  default:
    break;
}

export const serviceUrl = getBEUrl;
export const googleUrl =
  'https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=236294637564-cs746337sch63768tuhoreha1210ore8.apps.googleusercontent.com&redirect_uri=https://staging.api.fresherstoday.com/api/oauth/google/callback&scope=openid%20profile%20email&access_type=offline';

export const cloudServiceUrl = cloudUrl;
